



















import {Component, Prop, Vue} from 'vue-property-decorator';

interface TooltipOption {
  title: string,
  toolTipMessageList: string[]
}

// TODO: 삭선처리 로직 작성
// 할인/배송비 (C), 화면은 비슷하지만 돈계산이 조금씩 다르다.
@Component
export default class ToolTip extends Vue{
  @Prop({required: true})
  private tooltipOption!: TooltipOption

  private showTooltip: boolean = false

  private toggleShowTooltip(){
    this.showTooltip = !this.showTooltip
  }
}
